import { IRI } from '@/api';
import { startsWith } from 'lodash';

export default {
  payload: (state) => {
    const payload = Object.assign({}, state.item);

    payload.invitationCourses = payload.invitationCourses.map(invitationCourse => {
      if (invitationCourse && invitationCourse.id && !startsWith(invitationCourse.id, IRI.invitationCourse)) {
        invitationCourse.id = `${IRI.invitationCourse}${invitationCourse.id}`;
      }
      invitationCourse.expiresAt = payload.expiresAt;
      return invitationCourse;
    });

    return payload;
  },
};
